<div class="dining-plans" *ngIf="data">
    <div class="description">
        <finder-breadcrumb class="breadcrumb"
            [links]="breadcrumb"
            breadcrumb="{{data.labels?.breadcrumbTemplate}}">
        </finder-breadcrumb>
        <span>{{data.labels?.instructionalText}}</span>
    </div>

    <!-- Desktop: Single table -->
    <finder-dining-table *ngIf="!isMobile" class="dining-plan-table"
        [title]="data.labels?.tableTitle"
        [years]="data.years"
        [mealPeriods]="data.mealPeriods"
        [plans]="data.plans">
    </finder-dining-table>

    <!-- Mobile: One table per year -->
    <ng-container *ngIf="isMobile">
        <finder-dining-table *ngFor="let year of data.years"
            class="dining-plan-table"
            [years]="[year]"
            [title]="getDiningTableTitle(year)"
            [mealPeriods]="data.mealPeriods"
            [plans]="getPlansByYear(year)"
            [singleYear]="true">
        </finder-dining-table>
    </ng-container>
</div>
